import {
  EDITOR_SET_DISPLAY_WIDTH,
  EDITOR_TOGGLE_BREAKDOWN,
  EDITOR_OPEN_BREAKDOWN,
  EMAIL_REQUEST,
  EMAIL_FAILURE,
  EMAIL_SUCCESS,
  EDITOR_SWAP_MODULES,
  EDITOR_SELECT_MODULE,
  EDITOR_REMOVE_SELECTED_MODULE,
  EDITOR_UPDATE_MODULE_FIELD_VALUE,
  EDITOR_UPLOAD_MODULE_FIELD_VALUE,
  EDITOR_UPDATE_NAME_VALUE,
  EDITOR_UPDATE_SUBJECT_VALUE,
  EDITOR_UPDATE_TRANSLATION_VARIATION,
  EDITOR_INSERT_MODULE_REQUEST,
  EDITOR_INSERT_MODULE_SUCCESS,
  EMAIL_UPDATE_SUCCESS,
  EMAIL_CLEAR_TRANSLATIONS_SUCCESS,
  EMAIL_UPLOAD_TRANSLATIONS_SUCCESS,
} from "../constants/ActionTypes";
import { mapValues } from "lodash";

const initialState = {
  displayWidth: 600,
  breakdown: false,

  emailId: null,
  selectedModule: false,
  unsavedChanges: false,

  email: {
    subject: "Lorem ipsum",
    backgroundColour: "#f5f5f5",
    country: "uk",
    modules: [],
    EmailTemplate: {},
  },
};

const fieldsApplyObjectPatch = (fields, key, value) => {
  return mapValues(fields, (fieldValue, fieldKey, field) => {
    if (key.indexOf(".") === -1) {
      if (fieldKey != key) {
        return fieldValue;
      }
      return Object.assign({}, fieldValue, { value });
    } else {
      const keyParts = key.split(".");
      // console.log('KEYPARTS', key, keyParts)
      const newKey = keyParts.slice(1, keyParts.length).join(".");

      if (fieldKey != keyParts[0]) {
        return fieldValue;
      }
      return Object.assign(
        {},
        fieldValue,
        fieldsApplyObjectPatch(fieldValue, newKey, value)
      );
    }
  });
};

export default function editor(state = initialState, action) {
  switch (action.type) {
    case EDITOR_SET_DISPLAY_WIDTH:
      return Object.assign({}, state, {
        displayWidth: action.width,
      });

    case EDITOR_TOGGLE_BREAKDOWN:
      return Object.assign({}, state, {
        breakdown: !state.breakdown,
      });

    case EDITOR_OPEN_BREAKDOWN:
      return Object.assign({}, state, {
        breakdown: true,
      });

    case EMAIL_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: false,
        email: action.data,
      });

    case EMAIL_REQUEST:
      return Object.assign({}, state, {
        unsavedChanges: false,
        email: {},
        selectedModule: false,
      });

    case EMAIL_FAILURE:
      return Object.assign({}, state, {
        email: {
          failed: true,
        },
      });

    case EDITOR_SELECT_MODULE:
      return Object.assign({}, state, {
        selectedModule: action.index,
      });

    case EDITOR_REMOVE_SELECTED_MODULE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        selectedModule: false,
        email: Object.assign({}, state.email, {
          modules: state.email.modules.filter((module, index) => {
            return index !== state.selectedModule;
          }),
        }),
      });

    case EDITOR_UPDATE_MODULE_FIELD_VALUE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign(
          {},
          state.email,
          state.selectedModule === false && {
            fields: Object.assign({}, state.email.fields, {
              data: fieldsApplyObjectPatch(
                (state.email.fields && state.email.fields.data) ||
                  state.email.EmailTemplate.fields.data,
                action.fieldIndex,
                action.value
              ),
            }),
          },
          {
            modules: state.email.modules.map((module, index) => {
              if (index !== state.selectedModule) {
                return module;
              }
              return Object.assign({}, module, {
                fields: Object.assign({}, module.fields, {
                  data: fieldsApplyObjectPatch(
                    module.fields.data,
                    action.fieldIndex,
                    action.value
                  ),
                }),
                // fields: module.fields.map((field, fieldIndex) => {
                //     if(fieldIndex != action.fieldIndex) {
                //         return field;
                //     }
                //     return Object.assign({}, field, {
                //         value: action.value
                //     })
                // })
              });
            }),
          }
        ),
      });

    case EDITOR_UPLOAD_MODULE_FIELD_VALUE:
      const value =
        process.env.REACT_APP_API_ENDPOINT +
        "/api/clients/" +
        action.data.accountId +
        "/images/" +
        action.data.id +
        "/image";

      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign(
          {},
          state.email,
          state.selectedModule === false && {
            fields: Object.assign({}, state.email.fields, {
              data: fieldsApplyObjectPatch(
                (state.email.fields && state.email.fields.data) ||
                  state.email.EmailTemplate.fields.data,
                action.fieldIndex,
                value
              ),
            }),
          },
          {
            modules: state.email.modules.map((module, index) => {
              if (index != state.selectedModule) {
                return module;
              }

              return Object.assign({}, module, {
                fields: Object.assign({}, module.fields, {
                  data: fieldsApplyObjectPatch(
                    module.fields.data,
                    action.fieldIndex,
                    value
                  ),
                }),
              });
            }),
          }
        ),
      });

    case EDITOR_UPDATE_NAME_VALUE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign({}, state.email, {
          name: action.value,
        }),
      });

    case EDITOR_UPDATE_SUBJECT_VALUE:
      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign({}, state.email, {
          subject: action.value,
        }),
      });

    case EDITOR_UPDATE_TRANSLATION_VARIATION:
      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign({}, state.email, {
          var: action.value,
        }),
      });

    case EMAIL_UPLOAD_TRANSLATIONS_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign({}, state.email, {
          translations: action.data,
          var: action.data && Object.keys(action.data)[0],
        }),
      });

    case EMAIL_CLEAR_TRANSLATIONS_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign({}, state.email, {
          translations: null,
          var: null,
        }),
      });

    case EDITOR_SWAP_MODULES:
      // const list = state.email.modules;
      // console.log("LIST SWAP ==3432=43=432=4=32=432=4=32====")
      // console.log([ list[1], list[0] ] = [ list[0], list[1] ]);

      var original = state.email.modules[action.from];
      var filtered = state.email.modules.filter((module, index) => {
        return index !== action.from;
      });
      // var to = action.to > action.from ? action.to - 1: action.to;
      var to = action.to;

      // return state;
      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign({}, state.email, {
          modules: [].concat(
            filtered.slice(0, to),
            original,
            filtered.slice(to, filtered.length)
          ),
          // state.email.modules
          // .filter((module, index) => {
          //     console.log({
          //         index, actionI: action.from
          //     })
          //     return index !== action.from
          // })
          // [].concat(
          //     state.email.modules.slice(0,from),
          //     state.email.modules
          //     action.data,
          //     state.email.modules.slice(index, state.email.modules.length)
          // )
        }),
      });

    case EDITOR_INSERT_MODULE_REQUEST:
      var email = state.email;
      var index = action.index;
      return Object.assign({}, state, {
        email: Object.assign({}, email, {
          modules: email.modules.slice(0, index).concat(
            {
              name: "Loading...",
              loading: true,
            },
            email.modules.slice(index, email.modules.length)
          ),
        }),
      });

    case EDITOR_INSERT_MODULE_SUCCESS:
      var email = state.email;
      var index = action.index;
      var filtered = state.email.modules.filter((module, index) => {
        return module.loading !== true;
      });

      delete action.data.template;
      delete action.data.style;
      delete action.data.EmailTemplate;

      return Object.assign({}, state, {
        unsavedChanges: true,
        email: Object.assign({}, email, {
          modules: filtered
            .slice(0, index)
            .concat(action.data, filtered.slice(index, filtered.length)),
        }),
      });

    case EMAIL_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        unsavedChanges: false,
      });
  }

  return state;
}
